import React from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";

import { esignIcons } from "../../../../../components/Esign/icons";

const HeaderToolbar = ({ searchText, onSearchChange, onAddTemplate }) => {
  return (
    <Box
      mt={2}
      sx={{
        display: "flex",
        ml: "30px",
        mr: "30px",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontStyle: "SemiBold",
          fontSize: "20px",
          lineHeight: "100%",
          letterSpacing: "0%",
        }}
      >
        Email Templates
      </Typography>
      <Box display={"flex"} alignItems={"center"} gap={2}>
        <TextField
          value={searchText}
          placeholder="Search..."
          type="text"
          variant="outlined"
          onChange={onSearchChange}
          sx={{
            boxSizing: "border-box",
            borderRadius: "10px",
            backgroundColor: "#fff",
            borderColor: "#E8E8E9",
            borderWidth: "5px",
            "& .MuiOutlinedInput-root": {
              borderColor: "#E8E8E9",
              backgroundColor: "none",
              "&:hover fieldset": {
                borderColor: "#E8E8E9",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#E8E8E9",
              },
            },
            "& .MuiFormHelperText-root": {
              color: "#FF6666",
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                {esignIcons.searchIcon}
              </InputAdornment>
            ),
            sx: {
              borderRadius: "10px",
              width: 410,
              height: 40,
              fontSize: "16px",
              fontWeight: "500",
              "& input::-ms-reveal, & input::-ms-clear": {
                display: "none",
              },
              "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                {
                  display: "none",
                  WebkitAppearance: "none",
                  margin: 0,
                },
              "& input[type=number]": {
                MozAppearance: "textfield",
              },
            },
          }}
        />
        <Button
          onClick={onAddTemplate}
          sx={{
            width: 164,
            height: 40,
            textTransform: "none",
            borderRadius: "8px",
            background: "#185CB7",
            color: "#FFFFFF",
            fontWeight: 500,
            fontStyle: "Medium",
            fontSize: "14px",
            lineHeight: "100%",
            letterSpacing: "0%",
          }}
        >
          +Add Template
        </Button>
      </Box>
    </Box>
  );
};

export default HeaderToolbar;
